export const storeResetFns = new Set<() => void>();

export const resetStore = () => {
  storeResetFns.forEach((resetFn) => {
    resetFn();
  });
};
